import React, { useState, useEffect } from 'react';
import LitImage from './images/LitImage';
import Slider from 'react-slick';
import { Link } from 'gatsby';
import useScreenSize from '../hooks/useScreenSize';
import { graphql, useStaticQuery } from 'gatsby';
const ImageBannerCarousel = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    rows: 1,
    slidesToShow: 4,
    autoplay: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          dots: true,
        },
      },
    ],
  };
  const screenSize = useScreenSize();
  const { imageLinkContent, backgroundColor } = data;
  return (
    <div className={`image-banner-carousel-container ${backgroundColor}`}>
      <Slider {...settings}>
        {imageLinkContent?.map(
          ({
            image,
            mobileImage,
            buttonColor,
            buttonLeft,
            buttonPath,
            buttonText,
            backgroundColor,
            id,
          }) => {
            return (
              <div className="image-banner-carousel-inner" key={id}>
                <Link
                  key={id}
                  to={buttonPath}
                  title={buttonPath}
                  aria-label={buttonPath}
                >
                  <div
                    className={`image-banner-image ${backgroundColor} ${backgroundColor}-hover-highlight`}
                  >
                    <LitImage image={mobileImage} />
                  </div>
                </Link>
              </div>
            );
          },
        )}
      </Slider>
    </div>
  );
};

export default ImageBannerCarousel;
export const fragment = graphql`
  fragment ModularImageBannerCarousel on DatoCmsImageBannerCarousel {
    internal {
      type
    }
    backgroundColor
    imageLinkContent {
      id
      backgroundColor
      buttonColor
      buttonLeft
      buttonPath
      buttonText
      mobileImage {
        gatsbyImageData(width: 1000)
      }
      image {
        gatsbyImageData(width: 1000)
      }
    }
    imageBannerCarouselContent {
      id
      image {
        gatsbyImageData(width: 1000)
      }
    }
  }
`;
